import { ButtonModule } from '../../atoms/button/button.module';
import { MatSortModule } from '@angular/material/sort';
import { ActionBarModule } from '../action-bar/action-bar.module';
import { SvgIconModule } from '@core/modules/svgIcons.module';
import { MatTableModule } from '@angular/material/table';
import { TableComponent } from './table.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagsModule } from '../../atoms/tags/tags.module';
import { BytePipe } from '@core/pipes/byte.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CypressDirectiveModule } from '../../../directives/cypress/cypress-directive.module';
import {
  CheckboxModule,
  DropdownButtonModule,
  HideFilterPipe,
} from '@xt/ui-kit';

@NgModule({
  declarations: [TableComponent],
  imports: [
    CommonModule,
    MatTableModule,
    SvgIconModule,
    ActionBarModule,
    MatSortModule,
    TagsModule,
    ActionBarModule,
    DropdownButtonModule,
    TranslocoModule,
    MatTooltipModule,
    ButtonModule,
    CypressDirectiveModule,
    CheckboxModule,
    BytePipe,
    HideFilterPipe,
  ],
  exports: [TableComponent],
})
export class TableModule {}
